import { read_u32, read_u64, read_u8, Sink } from "../../helpers/serializerHelpers";
import { TrackState } from "./TrackState";

export class InferenceTrackState extends TrackState {
    public fusionStatus: number = 0;
    public inferredObjectId: bigint = BigInt(0);
    public associatedRadarId: number = 0;

    public deserialize(bytes: Sink) {
        super.deserialize(bytes);
        this.fusionStatus = read_u8(bytes);
        this.inferredObjectId = read_u64(bytes);
        this.associatedRadarId = read_u32(bytes);
        return this;
    }

    public override getLength() {
        return super.getLength() + 13; //additional 13 bytes from byte, uint64, and uint32
    }
}
